import { api } from '@wellesley/openapi'
import { handleBasicResponse } from '@wellesley/openapi/helpers'
import { toast } from '@wellesley/system-toast'
import getReduxKey from '../../feed/feedsSlice/helpers/getReduxKey'
import {
  BOOKMARKS_KEY,
  feedsSlice,
  FeedsSliceState,
} from 'components/feed/feedsSlice'

import { bookmarksSlice } from '../slices/bookmarksSlice'

const bookmarksApi = api.enhanceEndpoints({
  endpoints: {
    postApiV1PostsByPostIdBookmark: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        const postId = args.postId

        try {
          await handleBasicResponse(queryFulfilled)
          dispatch(bookmarksSlice.actions.savePost(postId))
        } catch (e) {
          toast.error(`Failed to add ${postId} to bookmarks`)
        }
      },
    },
    deleteApiV1PostsByPostIdBookmark: {
      async onQueryStarted(args, { dispatch, queryFulfilled, getState }) {
        const postId = args.postId

        try {
          await handleBasicResponse(queryFulfilled)
          dispatch(bookmarksSlice.actions.removePost(postId))

          const store = getState() as unknown as { feeds: FeedsSliceState }
          const isBookmarksStore =
            !!store.feeds?.data?.[getReduxKey(BOOKMARKS_KEY)]?.items.length

          isBookmarksStore &&
            dispatch(feedsSlice.actions.deletePost({ postId }))
        } catch (e) {
          toast.error(`Failed to remove ${postId} from bookmarks`)
        }
      },
    },
  },
})

export const {
  usePostApiV1PostsByPostIdBookmarkMutation,
  useDeleteApiV1PostsByPostIdBookmarkMutation,
} = bookmarksApi
